<template>
  <div>
    <div id="creditCardIframe" ref="creditCardIframe">
      <form
        class="paymentWidgets"
        data-brands="VISA MASTER AMEX"
        :action="formAction"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formAction: String,
    gatewayId: Number,
    checkoutId: String,
    submitButtonText: String,
    billingData: {
      type: Object,
      Default() {
        return {};
      },
    },
  },

  data() {
    return {
      wpwlScriptFilename: "js/wpwl-cnp-billing.js",
    };
  },

  mounted() {
    // Add event listener for from ready before creating script
    window.addEventListener("formReady", this.handleFormReadyEvent);
  },

  created() {
    console.log(this.formAction);
    
    // Set the global submitButtonText variable
    window.submitButtonText = this.submitButtonText;

    // Set the global billingData variable
    window.billingData = this.billingData;

    // Render the credit card options
    this.renderCreditCardOptions();
    // Render the credit card form with the given gatewayId and checkoutId
    this.renderCreditCardForm(this.gatewayId, this.checkoutId);
  },

  methods: {
    handleFormReadyEvent() {
      console.log("copyandpay ready");
      this.emitEvent("copyandpay-ready");
    },

    // Method to render the credit card form
    renderCreditCardForm(gatewayId, checkoutId) {
      const testBase = "https://eu-test.oppwa.com";
      const prodBase = "https://eu-prod.oppwa.com";
      var urlBase = "";

      // Determine the appropriate URL base based on the provided gatewayId
      if (gatewayId == 1) {
        urlBase = prodBase;
      } else if (gatewayId == 2) {
        urlBase = testBase;
      }

      // Construct the script endpoint URL
      const scriptEndpoint = `${urlBase}/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
      // Create a new script element
      const script = document.createElement("script");
      // Set the script's src attribute to the script endpoint
      script.setAttribute("src", scriptEndpoint);
      // Set the script's async attribute to true
      script.setAttribute("async", true);
      // Append the script element to the document body
      document.body.appendChild(script);
    },

    // Method to render the credit card options
    renderCreditCardOptions() {
      // Create a new script element for jQuery
      const jQuery = document.createElement("script");
      // Set the script's src attribute to the jQuery source
      jQuery.src = `https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js`;
      // Append the jQuery script element to the document body
      document.body.appendChild(jQuery);

      // Construct the wpwlOptionsPath
      const wpwlOptionsPath = `${process.env.BASE_URL}${this.wpwlScriptFilename}`;
      // Create a new script element for wpwlOptions
      const wpwlOptions = document.createElement("script");
      // Set the script's src attribute to the wpwlOptionsPath
      wpwlOptions.setAttribute("src", wpwlOptionsPath);
      // Append the wpwlOptions script element to the document head
      document.head.appendChild(wpwlOptions);
    },

    emitEvent(eventName, eventData = null) {
      this.$emit(eventName, eventData);
    },
  },

  onBeforeUnmount() {
    if (window.wpwl !== undefined && window.wpwl.unload !== undefined) {
      window.wpwl.unload();
      const scripts = document.querySelectorAll("script");
      scripts.forEach((script) => {
        if (!script.src.includes("static.min.js")) {
          document.head.removeChild(script);
        }
      });
    }
  },

  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener("formReady", this.listenFormReadyEvent);
  },
};
</script>

<style scoped>
::v-deep .wpwl-form {
  margin: 0 !important;
  max-width: 100% !important;
}

::v-deep .custom-outlined-input .v-input__control {
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  transition: border-color 0.2s;
}

::v-deep .custom-outlined-input .v-input__slot {
  padding: 1px 12px;
}
::v-deep .custom-outlined-input.v-input--is-focused .v-input__control {
  border-color: #448aff;
}

::v-deep .custom-outlined-input.v-input--is-focused .v-label {
  color: #448aff !important;
}

/* ::v-deep .wpwl-control {
  color: rgba(0, 0, 0, 0.5);
} */

::v-deep .wpwl-hint {
  display: none;
}
</style>
